<template>
    <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
        <div class="form tw-text-center tw-ml-auto tw-w-full tw-px-5 lg:tw-px-12 tw-flex tw-flex-col tw-items-center tw-justify-center">
            <img src="~@/assets/img/icons/success.svg">
            <div class="form-title tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center tw-font-bold tw-relative tw-leading-none tw-py-5">
                Obrigado pela sua simulação
            </div>
            <p class="tw-text-white tw-text-base tw-py-6">
                Irá ser contactado brevemente por um dos nossos consultores financeiros.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';

</style>
